import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useOfflineSession } from "@/core/hooks/useOfflineSession";

export default function HomePage() {
  const { isAuthenticated, isLoading } = useOfflineSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      navigate("/sites", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className="flex h-dvh items-center justify-center">
      <div className="text-muted-foreground">Chargement…</div>
    </div>
  );
}
